var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['checkbox', 'tip', _vm.generateCheckboxClass(_vm.field)],attrs:{"data-original-title":_vm.field.help,"data-placement":"bottom","data-toggle":"tooltip"}},[_c('switcher',{attrs:{"as_number":_vm.as_number},model:{value:(_vm.current_value),callback:function ($$v) {_vm.current_value=$$v},expression:"current_value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2057dd6f","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Forms/Elements/Switch.vue
// module id = 1769
// module chunks = 0